export enum SlotsBalanceActionType {
    Win = "Win",
    BigWin = "BigWin"
}
